import { Box, Flex, HStack, Tag, Text } from "@chakra-ui/react";
import { UI } from "components";

export default function Bank({ data, selected = false }){
    return(
    <Box py={2} px={4} borderWidth={selected ? 2 : 1} borderColor={selected ? 'orange.100' : null} borderRadius={4}>
        <HStack gap={4}>
            <UI.Icon name={data?.pix_key ? 'pix' : 'bank'} color="orange.fg" fontSize="30px" />
            <Box>
                <Tag.Root size="sm"><Tag.Label>{!!data?.pix_key ? 'Chave Pix' : 'Conta Bancária'}</Tag.Label></Tag.Root>
                <Text children={data?.label} fontSize="xs" />
            </Box>
        </HStack>
    </Box>
    )
}